import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HomePage } from './home';
import {ComponentsModule} from "../../components/components.module";
import {ContentLoaderModule} from "@netbasal/ngx-content-loader";

@NgModule({
  declarations: [
    HomePage,
  ],
  imports: [
    IonicPageModule.forChild(HomePage),
    ComponentsModule,
    ContentLoaderModule
  ],
  providers:[
  ]
})
export class HomePageModule {}



// WEBPACK FOOTER //
// ./src/pages/home/home.module.ts